export default __webpack_public_path__ + "static/media/emojiStale.38a21768.png";